import { sliderPhotosTpl } from '../../sliderPhotos/sliderPhotosTpl';

function capitalizeFirstLetter(str) {
  str = str.toLowerCase();
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/**
 * Surroundings popin template
 * @param {object} datas
 * @param {object} datas.data
 * @param {object} datas.wordings
 * @param {string} datas.urlBase
 * @return {string} - Formatted HTML
 */

const popinSurroundingsTpl = function (datas) {
  const poi = datas.poiData;
  const wordings = datas.wordings ? datas.wordings : [];
  const isIncluded = parseInt(poi.isPaying) === 0;
  const poiGroup = poi.group.code;
  const poiLocalName = poi.group.name;
  const poiName = capitalizeFirstLetter(poiLocalName);

  //-- Create filters tag
  let htmlFilters = '<ul class="popinSurroundings-filters">';
  let ageList = false;

  htmlFilters += `<li class='icon icon-budget'>${isIncluded ? PRODUCT_SCRIPTS.WORDING_PRODUCT.free : PRODUCT_SCRIPTS.WORDING_PRODUCT.paid}</li>`;

  if (!ageList && typeof poi.age.name !== 'undefined') {
    ageList = poi.age.code === 'MULTIGENERATION' ? PRODUCT_SCRIPTS.WORDING_PRODUCT.poi_all_ages : poi.age.name;
  } else if (poi.age.name !== undefined) {
    ageList += ', ' + poi.age.code === 'MULTIGENERATION' ? PRODUCT_SCRIPTS.WORDING_PRODUCT.poi_all_ages : poi.age.name;
  }

  if (ageList) {
    htmlFilters += `<li class='icon icon-baby'>${ageList}</li>`;
  }
  if (poi.distance !== undefined && poi.distance > 0) {
    htmlFilters += `<li class='icon icon-domain_map'>${poi.distance} km</li>`;
  }
  if (!poi.startDate && !poi.endDate) {
    htmlFilters += `<li class='icon icon-calendar'>${wordings.all_year_round}</li>`;
  }
  if (poi.startDate && poi.endDate) {
    const startMonth = `poi_month_${poi.startDate}`;
    const endMonth = `poi_month_${poi.endDate}`;
    htmlFilters += `<li class='icon icon-calendar'>${wordings[startMonth]} ${wordings.poi_month_to} ${wordings[endMonth]}</li>`;
  }

  htmlFilters += '</ul>';

  //gestion pictures
  let htmlPicture = '';
  const urlDesktopDefault = `${datas.urlBase}/assets/images/default/640x480.jpg`;
  const urlTabletDefault = `${datas.urlBase}/assets/images/default/640x480.jpg`;
  const urlMobileDefault = `${datas.urlBase}/assets/images/default/566x250.jpg`;

  if (!$.isEmptyObject(poi.photos)) {
    if(typeof poi.photos['640x480'] !== 'undefined' && poi.photos['640x480'].length > 1) {
      htmlPicture = sliderPhotosTpl({
        productCode: PRODUCT_SCRIPTS.PRODUCT_CODE,
        brandCode: PRODUCT_SCRIPTS.BRANDCODE,
        resolutionToUse: {
          desktop: '640x480',
          tablet: '640x480',
          mobile: '566x250'
        },
        openPopinOnClick: {
          desktop: false,
          tablet: false,
          mobile: false
        },
        photosDatas: poi.photos,
        videoDatas: poi.video ? poi.video : {},
        arrowTracking: '{"event":"clickEvent","clickCode":"ClickcPoiDetails","gaCategory":"Product Surroundings","gaAction":"poiDetails","gaLabel": "slider photos"}'
      });
    } else {
      if (!$.isEmptyObject(poi.video)) {
        htmlPicture += `
        <a href="#" class="popinSurroundings-video js-fancybox-video" data-url="${poi.video[0]}" data-type="videoLink">
          <i class="icon icon-play"></i>`;
      }
      htmlPicture += `
          <picture>
            <div class="blockNew"><span class="productLabel productLabel-${poiGroup.toLowerCase()}"><span class="icon icon-${poiGroup.toLowerCase()}"></span>${poiName}</span></div>
            <source srcset="${typeof poi.photos['566x250'] !== 'undefined' ? GLOBAL_SCRIPTS.BASELINK_MEDIA + poi.photos['566x250'][0] : urlMobileDefault}" media="(max-width: 767px)">
            <source srcset="${typeof poi.photos['640x480'] !== 'undefined' ? GLOBAL_SCRIPTS.BASELINK_MEDIA + poi.photos['640x480'][0] : urlTabletDefault}" media="(max-width: 1199px)">
            <img src="${typeof poi.photos['640x480'] !== 'undefined' ? GLOBAL_SCRIPTS.BASELINK_MEDIA + poi.photos['640x480'][0] : urlDesktopDefault}" alt="${poi.name}" itemprop="image">
          </picture>`;

      if (!$.isEmptyObject(poi.video)) {
        htmlPicture += `
        </a>`;
      }
    }
  } else {
    htmlPicture += `
    <picture>
      <div class="blockNew"><span class="productLabel productLabel-${poiGroup.toLowerCase()}"><span class="icon icon-${poiGroup.toLowerCase()}"></span>${poiName}</span></div>
      <source srcset="${urlMobileDefault}" media="(max-width: 767px)">
      <source srcset="${urlTabletDefault}" media="(max-width: 1199px)">
      <img src="${urlDesktopDefault}" alt="${poi.name}" itemprop="image">
    </picture>`;
  }

  const htmlpoiDescription = poi.description ? `<p>${poi.description}</p>` : '';

  const htmlpoiUrl = poi.website ? `<a target="_blank" href="${poi.website}" class="popinSurroundings-desc--link"><svg width="13" height="14" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13 14"><path d="M4.44 8.56l4.13-4.13M5.81 2.38l.32-.37C6.77 1.37 7.65 1 8.56 1c.91 0 1.79.36 2.43 1.01.64.64 1.01 1.52 1.01 2.43 0 .91-.36 1.79-1.01 2.43l-.37.32m-3.43 3.44-.27.37c-.65.64-1.53 1.01-2.45 1.01s-1.8-.36-2.45-1.01c-.32-.32-.58-.7-.75-1.11-.17-.42-.26-.87-.26-1.32s.09-.9.26-1.32c.17-.42.43-.8.75-1.11l.36-.32" fill="none" stroke="#00806C" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></svg>${wordings.poi_fancybox_know_more}</a>` : '';

  const itenararyStart = `${PRODUCT_SCRIPTS.lat},${PRODUCT_SCRIPTS.long}`;
  const itenararyEnd = `${poi.geo.lat},${poi.geo.lon}`;
  const htmlItinerary = poi.geo.lat && poi.geo.lon ? `<a target="_blank" href="https://www.google.com/maps/dir/?api=1&origin=${itenararyStart}&destination=${itenararyEnd}" class="popinSurroundings-itinerary--link button button--transparentBlack js-poiItinerary">${wordings.poi_map_itinerary}<span class="icon icon-out_link"></span></a>` : '';

  const htmlRegion = poi.region ? `<div class="popinSurroundings-copy"><span class="popinSurroundings-region">${poi.address}</span><span class="js-copyClipboard icon icon-copy"><span class="genericTooltip">${PRODUCT_SCRIPTS.WORDING_PRODUCT.poi_copy}</span></span></div>` : '';

  let arrowActivite = !!datas.prevPoiData ? `<span class="popinSurroundings-arrow popinSurroundings-arrow--left icon icon-arrow-left" data-code="${datas.prevPoiData}"></span>` : '';

  arrowActivite += !!datas.nextPoiData ? `<span class="popinSurroundings-arrow popinSurroundings-arrow--right icon icon-arrow-right" data-code="${datas.nextPoiData}"></span>` : '';

  return `
    <section class="popinSurroundings" id="poi-${poi.group.name}">
      <div class="popinSurroundings-top">
        <div class="popinSurroundings-visuals">
          ${htmlPicture}
        </div>
        <div class="popinSurroundings-infos">
          <div class="popinSurroundings-title">
            ${poi.name}
          </div>
          ${htmlFilters}
          ${htmlpoiUrl}
          <div class="popinSurroundings-desc">
            ${htmlpoiDescription}
          </div>
          <div class="popinSurroundings-cta">
            ${htmlRegion}
            ${htmlItinerary}
          </div>
        </div>
      </div>
      ${arrowActivite}
    </section>`;
};

export {popinSurroundingsTpl};